import Swal from 'sweetalert2';

export default function sweetAlert(text){

    Swal.fire({
                
        icon : 'error',
        title:text,
        confirmButtonText : 'متوجه شدم',
        confirmButtonColor : '#03ac13',
        
      })
}